import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* Below this width the nine-number row no longer fits beside the arrows. */
const WIDE_ROW_MIN_WIDTH = '640px';

export const nav = css`
  container-type: inline-size;
`;

export const row = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.sm});
`;

export const pages = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.md});
  margin: 0;
  padding: 0;
  list-style: none;
`;

/* Both rows are in the HTML; the space the pagination is given picks one. */
export const narrowPages = css`
  ${pages};

  @container (min-width: ${WIDE_ROW_MIN_WIDTH}) {
    display: none;
  }
`;

export const widePages = css`
  ${pages};
  display: none;

  @container (min-width: ${WIDE_ROW_MIN_WIDTH}) {
    display: flex;
  }
`;

export const page = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(${spacing.xs}) var(${spacing.md});
  border: 1px solid var(${colors.stroke.interactive});
  border-radius: var(${borderRadius.full.mobile});
  background-color: var(${colors.surface.default});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.interactive});
  text-decoration: none;

  &:hover {
    border-color: var(${colors.stroke.selected});
  }

  /* The theme has no tint for a selected pill, so the design's 10% wash is
     mixed from the selected stroke and still rethemes with it. */
  &[aria-current='page'] {
    border-color: var(${colors.stroke.selected});
    background-color: color-mix(
      in srgb,
      var(${colors.stroke.selected}) 10%,
      var(${colors.surface.default})
    );
  }
`;

export const ellipsis = css`
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
  color: var(${colors.content.interactive});
`;
